import React from 'react';

function Subtitle({index, message}) {
	return message.text;
}

export default Subtitle;